// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CircleDashedIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M12.032 4.631a1 1 0 0 1 .718-1.22c2.132-.55 4.368-.55 6.5 0a1 1 0 1 1-.5 1.937 11.011 11.011 0 0 0-5.5 0 1 1 0 0 1-1.218-.717ZM6.724 6.892a13.006 13.006 0 0 0-3.25 5.625 1 1 0 1 0 1.927.534 11 11 0 0 1 2.75-4.761 1 1 0 0 0-1.427-1.397ZM5.4 18.944a1 1 0 1 0-1.927.535 13.016 13.016 0 0 0 3.25 5.625A1 1 0 0 0 8.15 23.7 11.018 11.018 0 0 1 5.4 18.944Zm13.349 7.709a11 11 0 0 1-5.5 0 1 1 0 1 0-.5 1.936c2.132.55 4.368.55 6.5 0a1 1 0 0 0-.5-1.936Zm9.081-8.403a1.002 1.002 0 0 0-1.231.698 10.987 10.987 0 0 1-2.75 4.76 1 1 0 0 0 1.427 1.4 13 13 0 0 0 3.25-5.624.999.999 0 0 0-.696-1.234ZM26.6 13.057a1 1 0 1 0 1.927-.534 13 13 0 0 0-3.25-5.625A1 1 0 1 0 23.85 8.3a11 11 0 0 1 2.749 4.756v.002Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
